import { useRef, useEffect } from 'react';

export function useInterval(callback: () => void, delay?: number | null) {
  const savedCallback = useRef<typeof callback>(callback);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    const tick = () => {
      savedCallback.current();
    };

    if (delay !== null) {
      const intervalId = setInterval(tick, delay);
      return () => clearInterval(intervalId);
    }
  }, [delay]);
}
